import { useEffect, useState } from "react";
import { api, API_URL, fmtDate, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import PageHeader from "@/components/PageHeader";
import { Paperclip } from "lucide-react";

const STATUSES = ["Open", "In Progress", "Resolved"];
const chip = (s) => (s === "Resolved" ? "bg-emerald-100 text-emerald-700"
  : s === "In Progress" ? "bg-sky-100 text-sky-700" : "bg-amber-100 text-amber-700");

export default function SupportTickets() {
  const [list, setList] = useState([]);
  const [reply, setReply] = useState({});
  const load = () => api.get("/portal-admin/tickets").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const update = async (t, patch) => {
    try { await api.patch(`/portal-admin/tickets/${t.id}`, patch); toast.success("Ticket updated"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="space-y-5" data-testid="support-tickets-page">
      <PageHeader subtitle="Client Portal" title="Support Tickets" />
      <div className="space-y-3">
        {list.map((t) => (
          <div key={t.id} className="bg-white border border-slate-200 rounded-lg p-4">
            <div className="flex flex-wrap items-center gap-2 justify-between">
              <div className="text-sm">
                <span className="font-semibold text-slate-800">{t.subject}</span>
                <span className="ml-2 text-xs text-slate-500">— {t.company_name}</span>
                <span className={`ml-2 text-[10px] uppercase tracking-wider rounded px-1.5 py-0.5 ${chip(t.status)}`}>{t.status}</span>
                <span className="ml-2 text-[10px] uppercase tracking-wider text-slate-400">{t.kind}</span>
              </div>
              <div className="flex items-center gap-2">
                {t.file_id && (
                  <a href={`${API_URL}/portal-admin/files/${t.file_id}`} target="_blank" rel="noreferrer"
                     className="text-slate-400 hover:text-blue-600" title="Attachment" data-testid={`tk-file-${t.id}`}><Paperclip size={14} /></a>
                )}
                <select value={t.status} onChange={(e) => update(t, { status: e.target.value })}
                        className="text-xs border border-slate-200 rounded px-2 py-1.5" data-testid={`tk-status-${t.id}`}>
                  {STATUSES.map((s) => <option key={s}>{s}</option>)}
                </select>
              </div>
            </div>
            {t.message && <p className="text-[13px] text-slate-600 mt-2">{t.message}</p>}
            {t.reply && <p className="text-xs mt-2 bg-slate-50 border border-slate-100 rounded p-2"><span className="font-semibold text-[#3B82F6]">Reply:</span> {t.reply}</p>}
            <div className="flex gap-2 mt-3">
              <input value={reply[t.id] || ""} onChange={(e) => setReply({ ...reply, [t.id]: e.target.value })}
                     placeholder="Write a reply visible to the customer…"
                     className="flex-1 text-xs border border-slate-200 rounded-full px-3.5 py-2" data-testid={`tk-reply-${t.id}`} />
              <button onClick={() => reply[t.id] && update(t, { reply: reply[t.id] })}
                      className="text-xs bg-[#3B82F6] text-white rounded-full px-4" data-testid={`tk-reply-send-${t.id}`}>Send</button>
            </div>
            <div className="text-[10px] text-slate-400 mt-2">{fmtDate(t.created_at)}</div>
          </div>
        ))}
        {list.length === 0 && <p className="text-sm text-slate-400 py-10 text-center bg-white border border-slate-200 rounded-lg">No support tickets yet.</p>}
      </div>
    </div>
  );
}
